import React, { FC, useCallback } from 'react';
// components
import QrNotification from '../../atoms/qrNotification';
import QrScannerCamera from './QrScannerCamera';
// style
import './index.scss';
// localization
import strings from '../../../localization';

interface QrScanProps {
  data: string | null;
  handleScan: (data: string | null) => void;
  isScanned: boolean;
  handleError: (message: string) => void;
}

// Presents the mobile QR scan flow and post-scan confirmation state.
const QrScan: FC<QrScanProps> = ({ data, handleScan, isScanned, handleError }: QrScanProps) => {
  // Forwards decoded payload to parent while keeping a stable reference for the camera effect.
  const reportDecoded = useCallback((payload: string) => handleScan(payload), [handleScan]);

  // Forwards camera init failures to parent with a stable reference for the camera effect.
  const reportCameraError = useCallback((message: string) => handleError(message), [handleError]);

  return (
    <div className="qr-scan">
      <div className="qr-scan__inner">
        {isScanned ? (
          <QrNotification success={data ? true : false} />
        ) : (
          <>
            <div className="qr-scan__heading">
              <h3 className="page-heading small">{strings.connectPage.heading.headingScanQr}</h3>
            </div>

            <QrScannerCamera onResult={reportDecoded} onInitError={reportCameraError} />
          </>
        )}
      </div>
    </div>
  );
};

export default QrScan;
